"use client";

import React from "react";
import Box from "@sendsprint/ui-react/components/box";
import Container from "@sendsprint/ui-react/components/container";
import Typography from "@sendsprint/ui-react/components/typography";
import GlobalAccordion from "@/components/globalAccordion";
import useCampaign from "@/hooks/utils/useCampaign";
import { getHomeFaqData } from "../../data/faqs";

const HomeFaq = () => {
  const { registerLink, handleClearCampaignId } = useCampaign();
  return (
    <Box as="section" id="faq" className="ss:py-12 ss:md:py-20 ss:scroll-mt-20">
      <Container>
        <Typography
          variant="h5"
          tabletVariant="h3"
          className="ss:text-center   ss:font-bold ss:mb-8 ss:md:mb-12"
        >
          Frequently Asked Questions
        </Typography>
        <GlobalAccordion faqData={getHomeFaqData(registerLink, handleClearCampaignId)} />
      </Container>
    </Box>
  );
};

export default HomeFaq;
